import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Register } from '../../models/register';

import { UserRegistrationService} from '../../../services/user-registration.service';
import { CognitoCallback } from '../../../services/cognito.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';
import { EventEmitterService } from 'services/event-emitter.service';
import { TelephoneNumber } from 'app/models/telephone-number';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers: [UserRegistrationService]
})

export class RegisterComponent implements CognitoCallback, OnInit {
  model: Register = new Register();
  renderConfirm: boolean = false;
  hide: boolean = true;
  phoneNumber: TelephoneNumber = null;
  termsOfAgreementUrl = environment.termsOfAgreementUrl;
  triconDomain = environment.triconDomain;
  sub: any;

  constructor(public userRegistration: UserRegistrationService, public router: Router, private errorService: ErrorService, private splashService: SplashService, public route: ActivatedRoute) {
    if (this.router.url.includes("/public/register/confirm"))
    {
      this.renderConfirm = true;
    }
    else {
      this.sub = this.route.params.subscribe(params => {   
        if (params['callbackURL']) {
          localStorage.setItem('CallbackURL', params['callbackURL']);
          window.location.replace("/public/register");
        }
      });
    }
   }

  ngOnInit() {   
    this.splashService.updateSplash("register");
  }

  onSubmit() {
    this.model.Email = this.model.Email.toLowerCase();
    this.model.PhoneNumber = this.phoneNumber?.format() ?? "";
    this.userRegistration.register(this.model, this);
  }

  cognitoCallback(message: string, result: any) {
        if (message != null) {
          if (message.includes('email address exists')) {
            this.userRegistration.resendCode(this.model.Email, this);
          } else {
            this.errorService.showError(message);
          }
        } else {
            this.renderConfirm = true;
            this.router.navigate(['/public/register/confirm', result.user.username]);
        }
    }
    
  resendCodeCallback(error: any, result: any) {
    if (error != null) {
        this.errorService.showError(error);
    } else {
        this.errorService.showMessage("Email address exists, the Code has been resent. Please check your email.");
        this.renderConfirm = true;
        this.router.navigate(['/public/register/confirm', this.model.Email]);
    }
  }
  
}
